<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",

  metaInfo: {
    titleTemplate: "%s | Fontumi"
  }
};
</script>

<style>
.v-card__title {
  word-wrap: break-word !important;
}
</style>
